export default __webpack_public_path__ + "static/media/O-149.5f641b2f.png";